<template>
  <div class="grid grid-cols-2 h-full">
    <div class="h-full flex flex-col items-center text-center justify-center">
      <div class="w-12 h-12 bg-secondary mb-3 rounded-xl p-2">
        <ColorImg
          src="/images/icons/savings.svg"
          class="w-full h-ful bg-white"
          alt=""
        />
      </div>
      <div>
        <div class="text-gray-600">Commissions</div>
        <div class="text-xs -mt-1">Ce mois</div>
        <div class="title-color font-bold whitespace-nowrap mt-1">
          <DataFetcher dataKey="commissionsStats">
            <template #any="{ data }">
              {{ Commons.formatNumber(data?.total || 0) }}
            </template>
          </DataFetcher>
          <span class="text-xs">F</span>
        </div>
      </div>
    </div>
    <div class="h-full flex flex-col items-center text-center justify-center">
      <div class="w-12 h-12 bg-secondary mb-3 rounded-xl p-2">
        <ColorImg
          src="/images/icons/withdraw.svg"
          class="w-full h-ful bg-white"
          alt=""
        />
      </div>
      <div>
        <div class="text-gray-600">Retraits</div>
        <div class="text-xs -mt-1">Ce mois</div>
        <div class="title-color font-bold whitespace-nowrap mt-1">
          <DataFetcher dataKey="withdrawalsStats">
            <template #any="{ data }">
              {{ Commons.formatNumber(data?.total || 0) }}
            </template>
          </DataFetcher>
          <span class="text-xs">F</span>
        </div>
      </div>
    </div>
  </div>
  <ActionTrigger
    ref="launchWithdrawalTrigger"
    dataKey="launchWithdrawal"
    @success="
      () => {
        Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
          title: 'Retrait lancé',
          body: 'Veuillez vérifier votre compte mobile money',
        })
      }
    "
    @failed="
      err => {
        Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
          title: 'Echec de de retrait',
          body: `${err.result?.message || 'Erreur non détectéee. Code d\'erreur: ' + (err.result?.statusCode ?? 1000)}`,
        })
      }
    "
  />
</template>

<script setup>
import Events from '@/events/events'
import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import DataFetcher from '@/features/data/presentation/components/DataFetcher.vue'
import ColorImg from '@/presentation/components/img/ColorImg.vue'
import ImgComponent from '@/presentation/components/img/ImgComponent.vue'
import { EVENTS } from '@/shared/constants/commons'
import Commons from '@/shared/utils/commons'
import { ref } from 'vue'

const launchWithdrawalTrigger = ref(null)

async function requestWithdrawInfo() {
  const res = await window.customPrompt({
    title: 'Retrait Rapidoo',
    subTitle: 'Renseignez les informations requis pour les retrait',
    formFields: [
      {
        propertyName: 'amount',
        type: 'number',
        label: 'Montant à retirer',
        required: true,
      },
      {
        propertyName: 'phoneNumber',
        type: 'number',
        prefix: '229',
        label: 'Numéro de retrait',
        allowTrailingZero: true,
        required: true,
      },
    ],
    successText: 'Retirer',
    cancelText: 'Annuler',
  })
  if (!res?.accepted) return
  const data = {
    phoneNumber: res?.data?.phoneNumber,
    amount: res?.data?.amount,
  }
  launchWithdrawalTrigger?.value?.trigger(data)
}
</script>
